import { useLocation } from 'react-router-dom';
var ArticleBreadcrumbs = function ArticleBreadcrumbs(_ref) {
  var _id = _ref._id,
    breadcrumbs = _ref.breadcrumbs,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  if (!breadcrumbs || breadcrumbs.length === 0) return null;
  var cookie = pathname.split('/').filter(function (x) {
    return x.length > 0;
  }).filter(function (x) {
    return !['services', 'content'].includes(x.toLowerCase());
  }).map(function (x) {
    return x.replace(/--/g, '-');
  }).map(function (x) {
    return x.replace(/-/g, ' ');
  });
  if (cookie.length > 0 && cookie[cookie.length - 1].toLowerCase() === breadcrumbs.toLowerCase()) cookie.pop();
  return /*#__PURE__*/React.createElement("div", {
    className: "a__breadcrumbs",
    style: style
  }, /*#__PURE__*/React.createElement("h4", null, cookie.map(function (x) {
    return /*#__PURE__*/React.createElement("span", {
      key: "".concat(_id).concat(x)
    }, x, " / \xA0");
  }), breadcrumbs));
};
export default ArticleBreadcrumbs;